import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const SCROLL_THRESHOLD = 400;

/**
 * Floating control to smooth-scroll to the top after the user has scrolled down.
 */
export function BackToTop() {
  const { language } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SCROLL_THRESHOLD);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 end-6 z-[90] flex items-center gap-2 rounded-full border border-zinc-200 bg-white px-4 py-2.5 text-sm font-semibold text-zinc-800 shadow-lg ring-1 ring-black/5 transition hover:bg-zinc-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600 [-webkit-tap-highlight-color:transparent]"
      aria-label={language === 'en' ? 'Back to top' : 'חזרה למעלה'}
    >
      <ChevronUp className="h-4 w-4 shrink-0" aria-hidden />
      {language === 'en' ? 'Back to top' : 'חזרה למעלה'}
    </button>
  );
}
